import { useEffect, useRef, useState } from "react";
import recordStore from "@/store/record.store";
import RecordHelper from "@/bussiness/RecordHelper";
import Tooltip from "@/component/Tooltip";
import DownIcon from "@/assets/common/ic_down.svg?react";
import { maxRecordRoleId } from "@/constants/record";
import NoMessageTip from "./NoMessageTip";
import NoNetworkTip from "./NoNetworkTip";
import RecordList from "./RecordList";
import UnstableRecord from "./UnstableRecord";
import { IScrollInfo } from "@/component/LazyList/types";
import LazyList from "@/component/LazyList";
import { LazyListProvider } from "@/component/LazyList/LazyListContext";

export default function List() {
  const ref = useRef<HTMLDivElement>(null);
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const lazyListRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    ref.current?.scrollIntoView();
    setShowScrollToBottom(false);
    handleStartObserving();
  };

  const handleStartObserving = () => {
    if (ref.current) {
      observerRef.current?.observe(ref.current);
    }
  };

  const setMaxRoleId = async () => {
    recordStore.getState().setMaxRoleId(maxRecordRoleId);
  };

  useEffect(() => {
    recordStore.getState().resetRecentSpeakers();
    setMaxRoleId();
    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) {
          ref.current?.scrollIntoView();
        }
      },
      {
        root: lazyListRef.current,
        threshold: 0.7,
      }
    );
    observerRef.current.observe(ref.current!);

    const handleFocus = () => {
      ref.current?.scrollIntoView();
      setShowScrollToBottom(false);
    };

    window.addEventListener("focus", handleFocus);
    return () => {
      window.removeEventListener("focus", handleFocus);
      observerRef.current?.disconnect();
      RecordHelper.resetAvatarMap();
    };
  }, []);

  const debounceHandleScroll = (scrollInfo: IScrollInfo) => {
    if (
      scrollInfo.scrollTop >=
      scrollInfo.scrollHeight - scrollInfo.clientHeight - 40
    ) {
      setShowScrollToBottom(false);
      // 如果已经是底部了
    } else {
      setShowScrollToBottom(true);
    }
  };

  return (
    <>
      <div className="flex-1 overflow-scroll px-1.5">
        <ul
          className="flex justify-center h-100%"
        >
          <LazyListProvider>
            <LazyList
              className="w-full mt-4 overflow-auto my-scrollbar relative"
              onScroll={debounceHandleScroll}
              ref={lazyListRef}
            >
              <RecordList />
              <UnstableRecord />
              <div ref={ref} className="h-1"></div>
            </LazyList>
          </LazyListProvider>
        </ul>
      </div>
      {showScrollToBottom && (
        <Tooltip hover content={"回到当前"}>
          <div
            onClick={scrollToBottom}
            className="fixed bottom-30 right-20% size-10 border-1 border-solid b-color-#ECEEF3 rounded-50% flex justify-center items-center cursor-pointer bg-#fff"
          >
            <DownIcon className="size-4.5" />
          </div>
        </Tooltip>
      )}
      <NoMessageTip />
      <NoNetworkTip />
    </>
  );
}
